import React from 'react';

import { ButtonGroup, Button, Dialog, FormGroup, Input } from '@tencent/spaui';
import SuperAdminTab from './SuperAdminTab';
import EmployeeTab from './EmployeeTab';
import EmployeeManageTab from './EmployeeManageTab';
import AdOperationTab from './AdOperationTab';
import AgencyEmployeeTab from './AgencyEmployeeTab';
import HelperTab from './HelperTab';
import DataAnalyzerTab from './DataAnalyzer';

import { RPCFactory } from '../../../utils/RequestUtil';
import Role from '../../../consts/Role';
import { store } from '../../../store/Store';
import TipMsg from '../../../consts/TipMsg';
import { Common } from '../../../consts/Common';
import { GlobalStateAction } from '../../../actions/GlobalStateAction';
import { RegexFactory } from '../../../consts/RegexFactory';
import TipsType from '../../../consts/TipsType';

export default class RolePrivilegePage extends React.Component {
  componentDidMount() {
    RPCFactory.account
      .getEncryptionConfig()
      .done((data) => {
        const encyptStatus = {};
        const getStatus =
          (type) =>
          (obj = {}) => {
            Object.keys(obj).forEach((roleId) => {
              if (!encyptStatus[roleId]) {
                encyptStatus[roleId] = { [type]: !!parseInt(obj[roleId]) };
              } else {
                encyptStatus[roleId][type] = !!parseInt(obj[roleId]);
              }
            });
          };
        getStatus('leads')(data.leadsEncryptionConfig);
        getStatus('qw')(data.wxWorkEncryptionConfig);
        this.setState({ encyptStatus });
        // Object.keys(data || {}).forEach((roleId) => {
        //   this.update(roleId, data[roleId]);
        // });
      })
      .fail((ret, msg) => {
        window.alert(`错误信息：${msg}`);
      });

    RPCFactory.account
      .getEditReceiveLeadsConfig()
      .done((data) => {
        Object.keys(data || {}).forEach((roleId) => {
          this.updateReceiveLeads(roleId, data[roleId]);
        });
      })
      .fail((ret, msg) => {
        window.alert(`获取失败：${msg}`);
      });
    this.getPasswordInfo();
  }

  constructor(props) {
    super(props);

    this.pswDialogInit = {
      show: false,
      mobile: '',
      mobileHelpBlock: '',
      smsCode: '',
      smsCodeHelpBlock: '',
      smsCodeBtnDisable: false,
      password: '',
      passwordHelpBlock: '',
      countDownTips: '发送验证码',
      countDownSecs: 60,
      submitBtnDisable: false,
    };
    this.pswUpdateDialogInit = {
      show: false,
      password: '',
      passwordHelpBlock: '',
      newPassword: '',
      newPasswordHelpBlock: '',
      submitBtnDisable: false,
    };
    this.mobileUpdateDialogInit = {
      show: false,
      mobile: '',
      mobileHelpBlock: '',
      smsCode: '',
      smsCodeHelpBlock: '',
      smsCodeBtnDisable: false,
      countDownTips: '发送验证码',
      countDownSecs: 60,
      submitBtnDisable: false,
      countDownInterval: {},
    };
    // 取消独立密码设置
    this.pswDeleteDialogInit = {
      show: false,
      submitBtnDisable: false,
    };

    this.state = {
      tab: this.getRoleKeyFromUrl() || '1',
      encyptStatus: {},
      isOperatorReceiveLeads: false,
      isManageOperatorReceiveLeads: false,
      // 密保
      psw: {
        isSet: false,
        mobile: '',
      },

      // 新建账户密保手机和独立密码
      pswDialog: Object.assign({}, this.pswDialogInit),
      pswUpdateDialog: Object.assign({}, this.pswUpdateDialogInit),
      mobileUpdateDialog: Object.assign({}, this.mobileUpdateDialogInit),
      pswDeleteDialog: Object.assign({}, this.pswDeleteDialogInit),
    };
    this.listenToHash();
  }

  getPasswordInfo = () => {
    RPCFactory.account.getPasswordInfo().done((data) => {
      const psw = {
        isSet: !!data.mobile,
        mobile: data.mobile,
      };
      this.setState({ psw });
    });
  };
  update = (type, roleId, val) => {
    const encyptStatus = JSON.parse(JSON.stringify(this.state.encyptStatus));
    if (!encyptStatus[roleId]) {
      encyptStatus[roleId] = { [type]: !!val };
    } else {
      encyptStatus[roleId][type] = !!val;
    }
    console.log('encryptStatus', encyptStatus);
    this.setState({ encyptStatus });
  };
  updateReceiveLeads = (roleId, val) => {
    if (roleId == Role.OPERATOR_ROLE_LEADS_CEMPLOYEE.getCode()) {
      // 客服人员
      this.setState({ isOperatorReceiveLeads: !!parseInt(val) });
    } else if (roleId == Role.OPERATOR_ROLE_LEADS_CEMPLOYEE_MANAGER.getCode()) {
      // 客服经理
      this.setState({ isManageOperatorReceiveLeads: !!parseInt(val) });
    }
  };

  listenToHash = () => {
    window.addEventListener('hashchange', this.hashChangeHandler);
  };

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.hashChangeHandler);
  }

  hashChangeHandler = () => {
    const key = this.getRoleKeyFromUrl();
    if (key) {
      this.setState({
        tab: key,
      });
    }
  };
  getRoleKeyFromUrl = () => {
    const index = location.hash.indexOf('rolePrivileManage/');
    let key = undefined;
    if (index > -1) {
      const mapRoleToKey = {
        manager: 1,
        superManager: 2,
        employee: 3,
        employer: 4,
        agency: 5,
        adoperater: 6,
        assistant: 7,
      };
      const indexOfRole = index + 18;
      const roleName = location.hash.slice(indexOfRole);
      key = mapRoleToKey[roleName].toString();
    }
    return key;
  };
  onChange = (event, key) => {
    location.hash = '#/system/permission/';
    this.setState({
      tab: key,
    });
  };
  /**
   * 首次创建密保手机和独立密码
   * @type {{showPswDialog: EmployeeManagePage.psw.showPswDialog, hidePswDialog: EmployeeManagePage.psw.hidePswDialog, sendPsw: EmployeeManagePage.psw.sendPsw, onChangeMobile: EmployeeManagePage.psw.onChangeMobile, onChangeSMS: EmployeeManagePage.psw.onChangeSMS, onChangePassword: EmployeeManagePage.psw.onChangePassword, sendSMSCode: EmployeeManagePage.psw.sendSMSCode, submit: EmployeeManagePage.psw.submit}}
   */
  psw = {
    showPswDialog: () => {
      const { pswDialog } = this.state;
      pswDialog.show = true;
      this.setState({ pswDialog });
    },
    hidePswDialog: () => {
      clearInterval(this.countDownInterval);
      this.setState({ pswDialog: Object.assign({}, this.pswDialogInit) });
    },
    sendPsw: () => {
      RPCFactory.account
        .sendPsw()
        .done((data) => {
          const successMsg = TipMsg.SEND_SECRET_SUC;
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: successMsg,
            time: Common.DURATION_2_SEC,
            tipsType: TipsType.SUCCESS.getCode(),
          });
        })
        .fail((ret, msg) => {
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: msg,
            time: Common.DURATION_2_SEC,
            tipsType: TipsType.ERROR.getCode(),
          });
        });
    },
    onChangeMobile: (event, value = '') => {
      const len = value.length || 0;
      let helpBlock = '';
      if (len < 1) {
        helpBlock = '不能为空';
      } else {
        helpBlock = '';
      }
      const { pswDialog } = this.state;
      pswDialog.mobile = value;
      pswDialog.mobileHelpBlock = helpBlock;
      this.setState({ pswDialog });
    },
    onChangeSMS: (event, value = '') => {
      const len = value.length || 0;
      let helpBlock = '';

      if (len < 1) {
        helpBlock = '不能为空';
      } else {
        helpBlock = '';
      }
      const { pswDialog } = this.state;
      pswDialog.smsCode = value;
      pswDialog.smsCodeHelpBlock = helpBlock;
      this.setState({ pswDialog });
    },
    onChangePassword: (event, value = '') => {
      const len = value.length || 0;
      let helpBlock = '';

      if (len < 1) {
        helpBlock = '不能为空';
      } else {
        helpBlock = '';
      }
      const { pswDialog } = this.state;
      pswDialog.password = value;
      pswDialog.passwordHelpBlock = helpBlock;
      this.setState({ pswDialog });
    },
    sendSMSCode: () => {
      debugger;
      const { pswDialog } = this.state;
      pswDialog.smsCodeBtnDisable = false;
      const { mobile } = pswDialog;
      if (!RegexFactory.operationUserTelRegex.test(mobile)) {
        store.dispatch({
          type: GlobalStateAction.SHOW_TIPS,
          message: TipMsg.MOBILE_PARAM_ERROR,
          tipsType: TipsType.ERROR.getCode(),
          time: Common.DURATION_2_SEC,
        });
        this.setState({ pswDialog });
        return;
      }
      this.countDownInterval = setInterval(() => {
        const { pswDialog } = this.state;
        pswDialog.countDownSecs--;
        pswDialog.countDownTips = `${pswDialog.countDownSecs}s后重新发送`;
        pswDialog.smsCodeBtnDisable = true;
        this.setState({ pswDialog }, () => {
          if (this.state.pswDialog.countDownSecs == 0) {
            clearInterval(this.countDownInterval);
            const { pswDialog } = this.state;
            pswDialog.countDownSecs = 60;
            pswDialog.countDownTips = '发送验证码';
            pswDialog.smsCodeBtnDisable = false;
            this.setState({ pswDialog });
          }
        });
      }, 1000);

      RPCFactory.account
        .sendSMSCode(mobile)
        .done((data) => {
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: TipMsg.SEND_SMS_CODE_SUC,
            tipsType: TipsType.SUCCESS.getCode(),
            time: Common.DURATION_2_SEC,
          });
        })
        .fail((ret, msg) => {
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: msg,
            tipsType: TipsType.ERROR.getCode(),
            time: Common.DURATION_2_SEC,
          });
        });
    },
    submit: () => {
      const { pswDialog } = this.state;
      pswDialog.submitBtnDisable = false;
      const { mobile } = pswDialog;
      const { smsCode } = pswDialog;
      const { password } = pswDialog;

      if (!RegexFactory.mobile.test(mobile)) {
        pswDialog.mobileHelpBlock = TipMsg.MOBILE_PARAM_ERROR;
        this.setState({ pswDialog });
        return;
      }
      if (!RegexFactory.smsCode.test(smsCode)) {
        pswDialog.smsCodeHelpBlock = TipMsg.SMS_CODE_PARAM_ERROR;
        this.setState({ pswDialog });
        return;
      }
      if (!RegexFactory.password.test(password)) {
        pswDialog.passwordHelpBlock = TipMsg.SECOND_PSW_PARAM_ERROR;
        this.setState({ pswDialog });
        return;
      }

      RPCFactory.account
        .createAccountPassword(mobile, smsCode, password)
        .done((data) => {
          this.setState({ pswDialog });
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: TipMsg.UPDATE_SECRET_SUC,
            time: Common.DURATION_1_SEC,
            tipsType: TipsType.SUCCESS.getCode(),
          });
          const { psw } = this.state;
          psw.isSet = true;
          psw.mobile = mobile;
          this.setState({ psw });
          this.psw.hidePswDialog();
        })
        .fail((ret, msg) => {
          this.setState({ pswDialog });
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: msg,
            time: Common.DURATION_2_SEC,
            tipsType: TipsType.ERROR.getCode(),
          });
        });
    },
  };

  // 修改独立密码
  pswUpdate = {
    showPswDialog: () => {
      const { pswUpdateDialog } = this.state;
      pswUpdateDialog.show = true;
      this.setState({ pswUpdateDialog });
    },
    hidePswDialog: () => {
      this.setState({ pswUpdateDialog: Object.assign({}, this.pswUpdateDialogInit) });
    },
    onChangePassword: (event, value = '') => {
      const len = value.length || 0;
      let helpBlock = '';

      if (len < 1) {
        helpBlock = '不能为空';
      } else {
        helpBlock = '';
      }
      const { pswUpdateDialog } = this.state;
      pswUpdateDialog.password = value;
      pswUpdateDialog.passwordHelpBlock = helpBlock;
      this.setState({ pswUpdateDialog });
    },
    onChangeNewPassword: (event, value = '') => {
      const len = value.length || 0;
      let helpBlock = '';

      if (len < 1) {
        helpBlock = '不能为空';
      } else {
        helpBlock = '';
      }
      const { pswUpdateDialog } = this.state;
      pswUpdateDialog.newPassword = value;
      pswUpdateDialog.newPasswordHelpBlock = helpBlock;
      this.setState({ pswUpdateDialog });
    },
    submit: () => {
      const { pswUpdateDialog } = this.state;
      pswUpdateDialog.submitBtnDisable = false;
      const { password } = pswUpdateDialog;
      const { newPassword } = pswUpdateDialog;

      if (!RegexFactory.password.test(password)) {
        pswUpdateDialog.passwordHelpBlock = TipMsg.SECOND_PSW_PARAM_ERROR;
        this.setState({ pswUpdateDialog });
        return;
      }
      if (!RegexFactory.password.test(newPassword)) {
        pswUpdateDialog.newPasswordHelpBlock = TipMsg.SECOND_PSW_PARAM_ERROR;
        this.setState({ pswUpdateDialog });
        return;
      }

      RPCFactory.account
        .updateAccountPassword(password, newPassword)
        .done((data) => {
          this.setState({ pswUpdateDialog });
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: TipMsg.UPDATE_SECRET_SUC,
            time: Common.DURATION_1_SEC,
            tipsType: TipsType.SUCCESS.getCode(),
          });
          this.pswUpdate.hidePswDialog();
        })
        .fail((ret, msg) => {
          this.setState({ pswUpdateDialog });
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: msg,
            time: Common.DURATION_2_SEC,
            tipsType: TipsType.ERROR.getCode(),
          });
        });
    },
  };

  // 修改密保手机
  mobileUpdate = {
    showDialog: () => {
      const { mobileUpdateDialog } = this.state;
      mobileUpdateDialog.show = true;
      this.setState({ mobileUpdateDialog });
    },
    hideDialog: () => {
      clearInterval(this.countDownInterval);
      this.setState({ mobileUpdateDialog: Object.assign({}, this.mobileUpdateDialogInit) });
    },
    onChangeMobile: (event, value = '') => {
      const len = value.length || 0;
      let helpBlock = '';
      if (len < 1) {
        helpBlock = '不能为空';
      } else {
        helpBlock = '';
      }
      const { mobileUpdateDialog } = this.state;
      mobileUpdateDialog.mobile = value;
      mobileUpdateDialog.mobileHelpBlock = helpBlock;
      this.setState({ mobileUpdateDialog });
    },
    onChangeSMS: (event, value = '') => {
      const len = value.length || 0;
      let helpBlock = '';

      if (len < 1) {
        helpBlock = '不能为空';
      } else {
        helpBlock = '';
      }
      const { mobileUpdateDialog } = this.state;
      mobileUpdateDialog.smsCode = value;
      mobileUpdateDialog.smsCodeHelpBlock = helpBlock;
      this.setState({ mobileUpdateDialog });
    },
    sendSMSCode: () => {
      const { mobileUpdateDialog } = this.state;
      mobileUpdateDialog.smsCodeBtnDisable = false;
      const { mobile } = mobileUpdateDialog;
      if (!RegexFactory.operationUserTelRegex.test(mobile)) {
        store.dispatch({
          type: GlobalStateAction.SHOW_TIPS,
          message: TipMsg.MOBILE_PARAM_ERROR,
          tipsType: TipsType.ERROR.getCode(),
          time: Common.DURATION_2_SEC,
        });
        this.setState({ mobileUpdateDialog });
        return;
      }
      this.countDownInterval = setInterval(() => {
        const { mobileUpdateDialog } = this.state;
        mobileUpdateDialog.countDownSecs--;
        mobileUpdateDialog.countDownTips = `${mobileUpdateDialog.countDownSecs}s后重新发送`;
        mobileUpdateDialog.smsCodeBtnDisable = true;
        this.setState({ mobileUpdateDialog }, () => {
          if (this.state.mobileUpdateDialog.countDownSecs == 0) {
            clearInterval(this.countDownInterval);
            const { mobileUpdateDialog } = this.state;
            mobileUpdateDialog.countDownSecs = 60;
            mobileUpdateDialog.countDownTips = '发送验证码';
            mobileUpdateDialog.smsCodeBtnDisable = false;
            this.setState({ mobileUpdateDialog });
          }
        });
      }, 1000);
      RPCFactory.account
        .sendSMSCode(mobile)
        .done((data) => {
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: TipMsg.SEND_SMS_CODE_SUC,
            tipsType: TipsType.SUCCESS.getCode(),
            time: Common.DURATION_2_SEC,
          });
        })
        .fail((ret, msg) => {
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: msg,
            tipsType: TipsType.ERROR.getCode(),
            time: Common.DURATION_2_SEC,
          });
        });
    },
    submit: () => {
      const { mobileUpdateDialog } = this.state;
      mobileUpdateDialog.submitBtnDisable = false;
      const { mobile } = mobileUpdateDialog;
      const { smsCode } = mobileUpdateDialog;

      if (!RegexFactory.mobile.test(mobile)) {
        mobileUpdateDialog.mobileHelpBlock = TipMsg.MOBILE_PARAM_ERROR;
        this.setState({ mobileUpdateDialog });
        return;
      }
      if (!RegexFactory.smsCode.test(smsCode)) {
        mobileUpdateDialog.smsCodeHelpBlock = TipMsg.SMS_CODE_PARAM_ERROR;
        this.setState({ mobileUpdateDialog });
        return;
      }
      RPCFactory.account
        .updateAccountPswMobile(mobile, smsCode)
        .done((data) => {
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: TipMsg.UPDATE_MOBILE_SUC,
            time: Common.DURATION_1_SEC,
            tipsType: TipsType.SUCCESS.getCode(),
          });
          const { psw } = this.state;
          psw.mobile = mobile;
          this.setState({ psw, mobileUpdateDialog });
          this.mobileUpdate.hideDialog();
        })
        .fail((ret, msg) => {
          this.setState({ mobileUpdateDialog });
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: msg,
            time: Common.DURATION_2_SEC,
            tipsType: TipsType.ERROR.getCode(),
          });
        });
    },
  };

  // 取消独立密码设置
  pswDelete = {
    showDelDialog: () => {
      const { pswDeleteDialog } = this.state;
      pswDeleteDialog.show = true;
      this.setState({ pswDeleteDialog });
    },
    hideDelDialog: () => {
      this.setState({ pswDeleteDialog: Object.assign({}, this.pswDeleteDialogInit) });
    },

    submit: () => {
      const { pswDeleteDialog } = this.state;
      pswDeleteDialog.submitBtnDisable = false;
      RPCFactory.account
        .deleteAccountPsw()
        .done(() => {
          const { psw } = this.state;
          psw.isSet = false;
          this.setState({ pswDeleteDialog, psw });
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: TipMsg.DELETE_SECRET_SUC,
            time: Common.DURATION_1_SEC,
            tipsType: TipsType.SUCCESS.getCode(),
          });
          this.pswDelete.hideDelDialog();
        })
        .fail((ret, msg) => {
          this.setState({ pswDeleteDialog });
          store.dispatch({
            type: GlobalStateAction.SHOW_TIPS,
            message: msg,
            time: Common.DURATION_2_SEC,
            tipsType: TipsType.ERROR.getCode(),
          });
        });
    },
  };

  render() {
    const addyuangong = {
      width: '580px',
    };
    const canShowPSW =
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_MANAGER' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CMANAGER';

    return (
      <div className="main">
        <Dialog
          type="normal"
          style={addyuangong}
          title="设置独立密码"
          show={this.state.pswDialog.show}
          onSubmit={() => {
            const { pswDialog } = this.state;
            pswDialog.submitBtnDisable = true;
            this.setState({ pswDialog }, this.psw.submit);
          }}
          onCancel={this.psw.hidePswDialog}
          onClose={this.psw.hidePswDialog}
          disabled={this.state.pswDialog.submitBtnDisable}
        >
          <div className="configs">
            <ul className="config-list">
              <li className="config-li">
                <p className="name">手机号</p>
                <div className="form-in">
                  <FormGroup
                    feedback={`${this.state.pswDialog.mobile.length}/${11}`}
                    helpBlock={this.state.pswDialog.mobileHelpBlock}
                    status={this.state.pswDialog.mobileHelpBlock ? 'error' : ''}
                  >
                    <Input
                      placeholder="请输入当前账号的验证手机号"
                      maxLength="11"
                      value={this.state.pswDialog.mobile}
                      className={'without-spin-button'}
                      onChange={this.psw.onChangeMobile}
                      type="number"
                    />
                  </FormGroup>
                </div>
              </li>
              <li className="config-li">
                <p className="name">验证码</p>
                <div className="form-in">
                  <div className="fe-flex">
                    <div className="fe-flexBox">
                      <FormGroup
                        feedback={`${this.state.pswDialog.smsCode.length}/${6}`}
                        helpBlock={this.state.pswDialog.smsCodeHelpBlock}
                        status={this.state.pswDialog.smsCodeHelpBlock ? 'error' : ''}
                      >
                        <Input
                          placeholder="请输入验证码"
                          maxLength="6"
                          className={'input-verify-code without-spin-button'}
                          value={this.state.pswDialog.smsCode}
                          onChange={this.psw.onChangeSMS}
                          type="number"
                        />
                      </FormGroup>
                    </div>
                    <Button
                      disabled={this.state.pswDialog.smsCodeBtnDisable}
                      onClick={() => {
                        const { pswDialog } = this.state;
                        pswDialog.smsCodeBtnDisable = true;
                        this.setState({ pswDialog }, this.psw.sendSMSCode);
                      }}
                    >
                      {this.state.pswDialog.countDownTips}
                    </Button>
                  </div>
                </div>
              </li>
              <li className="config-li">
                <p className="name">独立密码</p>
                <div className="form-in">
                  <FormGroup
                    feedback={`${this.state.pswDialog.password.length}/${6}`}
                    helpBlock={this.state.pswDialog.passwordHelpBlock}
                    status={this.state.pswDialog.passwordHelpBlock ? 'error' : ''}
                  >
                    <Input
                      placeholder="请设置独立密码，格式为6位数字"
                      maxLength="6"
                      value={this.state.pswDialog.password}
                      className={'without-spin-button'}
                      onChange={this.psw.onChangePassword}
                      type="number"
                    />
                  </FormGroup>
                </div>
              </li>
            </ul>
          </div>
        </Dialog>

        <Dialog
          type="normal"
          title="修改密码"
          style={addyuangong}
          show={this.state.pswUpdateDialog.show}
          onSubmit={() => {
            const { pswUpdateDialog } = this.state;
            pswUpdateDialog.submitBtnDisable = true;
            this.setState({ pswUpdateDialog }, this.pswUpdate.submit);
          }}
          onCancel={this.pswUpdate.hidePswDialog}
          onClose={this.pswUpdate.hidePswDialog}
        >
          <div className="configs">
            <ul className="config-list">
              <li className="config-li">
                <p className="name">请填写原始独立密码</p>
                <div className="form-in">
                  <FormGroup
                    feedback={`${this.state.pswUpdateDialog.password.length}/${6}`}
                    helpBlock={this.state.pswUpdateDialog.passwordHelpBlock}
                    status={this.state.pswUpdateDialog.passwordHelpBlock ? 'error' : ''}
                  >
                    <Input
                      placeholder="请设置独立密码，格式为6位数字"
                      maxLength="6"
                      value={this.state.pswUpdateDialog.password}
                      className={'without-spin-button'}
                      onChange={this.pswUpdate.onChangePassword}
                      type="number password"
                    />
                  </FormGroup>
                </div>
              </li>
              <li className="config-li">
                <p className="name">请填写新的独立密码</p>
                <div className="form-in">
                  <FormGroup
                    feedback={`${this.state.pswUpdateDialog.newPassword.length}/${6}`}
                    helpBlock={this.state.pswUpdateDialog.newPasswordHelpBlock}
                    status={this.state.pswUpdateDialog.newPasswordHelpBlock ? 'error' : ''}
                  >
                    <Input
                      placeholder="请设置独立密码，格式为6位数字"
                      maxLength="6"
                      value={this.state.pswUpdateDialog.newPassword}
                      className={'without-spin-button'}
                      onChange={this.pswUpdate.onChangeNewPassword}
                      type="number password"
                    />
                  </FormGroup>
                </div>
              </li>
            </ul>
          </div>
        </Dialog>

        <Dialog
          type="normal"
          style={addyuangong}
          title="修改密保手机"
          show={this.state.mobileUpdateDialog.show}
          onSubmit={() => {
            const { mobileUpdateDialog } = this.state;
            mobileUpdateDialog.submitBtnDisable = true;
            this.setState({ mobileUpdateDialog }, this.mobileUpdate.submit);
          }}
          onCancel={this.mobileUpdate.hideDialog}
          onClose={this.mobileUpdate.hideDialog}
          disabled={this.state.mobileUpdateDialog.submitBtnDisable}
        >
          <div className="configs">
            <ul className="config-list">
              <li className="config-li">
                <p className="name">手机号</p>
                <div className="form-in">
                  <FormGroup
                    feedback={`${this.state.mobileUpdateDialog.mobile.length}/${11}`}
                    helpBlock={this.state.mobileUpdateDialog.mobileHelpBlock}
                    status={this.state.mobileUpdateDialog.mobileHelpBlock ? 'error' : ''}
                  >
                    <Input
                      placeholder="请输入变更后的密保手机"
                      maxLength="11"
                      value={this.state.mobileUpdateDialog.mobile}
                      className={'without-spin-button'}
                      onChange={this.mobileUpdate.onChangeMobile}
                      type="number"
                    />
                  </FormGroup>
                </div>
              </li>

              <li className="config-li">
                <p className="name">验证码</p>
                <div className="form-in">
                  <div className="fe-flex">
                    <div className="fe-flexBox">
                      <FormGroup
                        feedback={`${this.state.mobileUpdateDialog.smsCode.length}/${6}`}
                        helpBlock={this.state.mobileUpdateDialog.smsCodeHelpBlock}
                        status={this.state.mobileUpdateDialog.smsCodeHelpBlock ? 'error' : ''}
                      >
                        <Input
                          placeholder="请输入验证码"
                          maxLength="6"
                          className={'input-verify-code without-spin-button'}
                          value={this.state.mobileUpdateDialog.smsCode}
                          onChange={this.mobileUpdate.onChangeSMS}
                          type="number"
                        />
                      </FormGroup>
                    </div>
                    <Button
                      disabled={this.state.mobileUpdateDialog.smsCodeBtnDisable}
                      onClick={() => {
                        const { mobileUpdateDialog } = this.state;
                        mobileUpdateDialog.smsCodeBtnDisable = true;
                        this.setState({ mobileUpdateDialog }, this.mobileUpdate.sendSMSCode);
                      }}
                    >
                      {this.state.mobileUpdateDialog.countDownTips}
                    </Button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </Dialog>

        <Dialog
          type="normal"
          className="spaui-dialog-confirm-normal"
          title="确定取消独立密码设置?"
          // iconType='tip'
          show={this.state.pswDeleteDialog.show}
          onSubmit={() => {
            const { pswDeleteDialog } = this.state;
            pswDeleteDialog.submitBtnDisable = true;
            this.setState({ pswDeleteDialog }, this.pswDelete.submit);
          }}
          onClose={this.pswDelete.hideDelDialog}
          onCancel={this.pswDelete.hideDelDialog}
        >
          <div>取消独立密码设置后，密保手机也随之取消，管理人员进入线索管理平台无需二次输入密码。</div>
        </Dialog>
        <div className="pages-card role-set">
          {canShowPSW && (
            <div className="card padding-normal">
              <div className="card-tip-content">
                {this.state.psw.isSet ? (
                  <div className="set-psw">
                    <span>密保手机：{this.state.psw.mobile}，您可以点击</span>
                    <a style={{ cursor: 'pointer' }} onClick={this.psw.sendPsw}>
                      获取密码
                    </a>
                    <a style={{ cursor: 'pointer' }} onClick={this.pswUpdate.showPswDialog}>
                      修改密码
                    </a>
                    <a style={{ cursor: 'pointer' }} onClick={this.mobileUpdate.showDialog}>
                      修改密保手机
                    </a>
                    <a style={{ cursor: 'pointer' }} onClick={this.pswDelete.showDelDialog}>
                      取消独立密码设置
                    </a>
                  </div>
                ) : (
                  <div className="set-psw">
                    为确保数据安全，管理员可设置独立密码。设置后，所有管理员需输入密码才可进入线索管理平台。立即
                    <a style={{ cursor: 'pointer' }} onClick={this.psw.showPswDialog}>
                      设置独立密码
                    </a>
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="card padding-normal">
            <div className="card-title">角色权限管理</div>
            <div className="card-option">
              <div className="tags-button">
                <ButtonGroup onChange={this.onChange} value={this.state.tab}>
                  <Button value="1">超级管理员</Button>
                  <Button value="2">普通管理员</Button>
                  <Button value="3">客服经理</Button>
                  <Button value="4">客服人员</Button>
                  <Button value="5">服务商人员</Button>
                  <Button value="6">广告优化师</Button>
                  <Button value="7">线索转发助手</Button>
                  <Button value="8">数据分析人员</Button>
                </ButtonGroup>
              </div>
              <div className="role-set-content">
                {this.state.tab == '1' && <SuperAdminTab />}
                {this.state.tab == '2' && <SuperAdminTab />}
                {this.state.tab == '3' && (
                  <EmployeeManageTab
                    key={this.state.tab}
                    encrypt={this.state.encyptStatus}
                    receiveLeads={this.state.isManageOperatorReceiveLeads}
                    update={this.update}
                    updateReceiveLeads={this.updateReceiveLeads}
                  />
                )}
                {this.state.tab == '4' && (
                  <EmployeeTab
                    key={this.state.tab}
                    encrypt={this.state.encyptStatus}
                    receiveLeads={this.state.isOperatorReceiveLeads}
                    update={this.update}
                    updateReceiveLeads={this.updateReceiveLeads}
                  />
                )}
                {this.state.tab == '5' && (
                  <AgencyEmployeeTab key={this.state.tab} encrypt={this.state.encyptStatus} update={this.update} />
                )}
                {this.state.tab == '6' && (
                  <AdOperationTab key={this.state.tab} encrypt={this.state.encyptStatus} update={this.update} />
                )}
                {this.state.tab == '7' && (
                  <HelperTab key={this.state.tab} encrypt={this.state.encyptStatus} update={this.update} />
                )}
                {this.state.tab == '8' && (
                  <DataAnalyzerTab key={this.state.tab} encrypt={this.state.encyptStatus} update={this.update} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
